import { GoDotFill } from 'react-icons/go';
import { MdOutlineKeyboardBackspace } from 'react-icons/md'

interface PropData {
    title: string,
    backArrow?: boolean,
    active?: boolean
}

const PageTitle = (props: PropData) => {

    const goBack = () => { window.history.back(); };
    return (
        <>
            <div className=" mb-3">
                <div className="d-flex align-items-center gap-2">
                    {
                        props?.backArrow == true
                            ?
                            (
                                <a onClick={goBack} href="javascript:void(0)" className="left-arrow mr-3 text-brand">
                                    <MdOutlineKeyboardBackspace size={24} />
                                </a>
                            )
                            :
                            null
                    }
                    <div className="page-title">
                        {props.title}{props.active ? <GoDotFill className='text-danger p-0' size={20} /> : <GoDotFill className='text-success p-0' size={20} />}
                    </div>
                </div>
            </div>
        </>
    );
};

export default PageTitle;